function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), React.createElement("defs", null, React.createElement("path", {
  d: "M10 7.273c-.636 0-1.136-.5-1.136-1.137C8.864 5.5 9.364 5 10 5c.636 0 1.136.5 1.136 1.136 0 .637-.5 1.137-1.136 1.137zm0-1.818a.67.67 0 00-.682.681.67.67 0 00.682.682.67.67 0 00.682-.682.67.67 0 00-.682-.681zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-18.182A8.177 8.177 0 001.818 10 8.177 8.177 0 0010 18.182 8.177 8.177 0 0018.182 10 8.177 8.177 0 0010 1.818zm0 13.41c-.5 0-.91-.41-.91-.91V9.091c0-.5.41-.91.91-.91s.91.41.91.91v5.227c0 .5-.41.91-.91.91zm0-8.183a.91.91 0 110-1.818.91.91 0 010 1.818z",
  id: "info-icon-path"
})), React.createElement("use", {
  fill: "currentColor",
  fillRule: "nonzero",
  xlinkHref: "#info-icon-path"
})));